'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _orderBy2 = require('lodash/orderBy');

var _orderBy3 = _interopRequireDefault(_orderBy2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _desc, _value, _class2, _descriptor, _descriptor2, _class3, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactTable = require('react-table');

var _reactTable2 = _interopRequireDefault(_reactTable);

var _selectTable = require('react-table/lib/hoc/selectTable');

var _selectTable2 = _interopRequireDefault(_selectTable);

var _util = require('../../utils/util');

var _TableRenderingUtils = require('../../utils/TableRenderingUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var CheckboxTable = (0, _selectTable2.default)(_reactTable2.default);

var DocumentTableBody = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp2 = _class3 = function (_Component) {
  _inherits(DocumentTableBody, _Component);

  function DocumentTableBody() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DocumentTableBody);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DocumentTableBody.__proto__ || Object.getPrototypeOf(DocumentTableBody)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'selectAllRows', _descriptor, _this), _initDefineProp(_this, 'selectedRows', _descriptor2, _this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DocumentTableBody, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          documents = _props.documents,
          selectedDocumentIds = _props.selectedDocumentIds;


      if (selectedDocumentIds) {
        this.selectedRows = selectedDocumentIds;

        if (documents.length === selectedDocumentIds.length) {
          this.selectAllRows = true;
        }
      }
    }
  }, {
    key: 'isRowSelected',
    value: function isRowSelected(key) {
      return this.selectedRows.includes(key);
    }
  }, {
    key: 'onSelectRows',
    value: function onSelectRows(selectedRows) {
      this.selectedRows = selectedRows;
      this.props.onCheck(this.selectedRows);
    }
  }, {
    key: 'toggleRowSelection',
    value: function toggleRowSelection(key, shift, row) {
      var selectedRows = (0, _util.toggleArrayIncludes)((0, _mobx.toJS)(this.selectedRows), key);
      this.onSelectRows(selectedRows);
    }
  }, {
    key: 'toggleSelectAllRows',
    value: function toggleSelectAllRows() {
      var newSelectedRows = [];

      if (!this.selectAllRows) {
        newSelectedRows = this.orderedDocuments.map(function (document) {
          return document.id;
        });
      }

      this.selectAllRows = !this.selectAllRows;
      this.onSelectRows(newSelectedRows);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          columns = _props2.columns,
          hasHeader = _props2.hasHeader,
          selectable = _props2.selectable,
          title = _props2.title,
          TableComponent = selectable ? CheckboxTable : _reactTable2.default,
          checkboxProps = {
        isSelected: this.isRowSelected,
        selectAll: this.selectAllRows,
        selectedRows: this.selectedRows,
        selectType: 'checkbox',
        selectWidth: 25,
        toggleAll: this.toggleSelectAllRows,
        toggleSelection: this.toggleRowSelection
      },
          classNames = (0, _classnames2.default)('-list -single-line', { '-selectable': selectable }, { '-no-header': !hasHeader }),
          defaultSorted = hasHeader ? [{ desc: true, id: 'created_at' }] : undefined,
          SelectAllInputComponent = _TableRenderingUtils.SelectInputComponent;


      SelectAllInputComponent.defaultProps = {
        listTitle: title
      };

      return _react2.default.createElement(TableComponent, _extends({
        className: classNames,
        columns: columns,
        data: this.orderedDocuments,
        defaultSorted: defaultSorted,
        keyField: 'id',
        pageSize: this.orderedDocuments.length,
        minRows: 0,
        resizable: false,
        sortable: false,
        SelectAllInputComponent: SelectAllInputComponent,
        SelectInputComponent: _TableRenderingUtils.SelectInputComponent,
        showPagination: false
      }, checkboxProps));
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }, {
    key: 'orderedDocuments',
    get: function get() {
      return (0, _orderBy3.default)(this.props.documents, ['created_at', 'file'], ['desc', 'desc']);
    }
  }]);

  return DocumentTableBody;
}(_react.Component), _class3.defaultProps = {
  onCheck: _noop3.default
}, _class3.propTypes = {
  columns: _mobxReact.propTypes.arrayOrObservableArray.isRequired,
  documents: _mobxReact.propTypes.arrayOrObservableArray.isRequired,
  hasHeader: _propTypes2.default.bool,
  onCheck: _propTypes2.default.func,
  selectable: _propTypes2.default.bool,
  selectedDocumentIds: _mobxReact.propTypes.arrayOrObservableArray,
  title: _propTypes2.default.string
}, _temp2), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'selectAllRows', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'selectedRows', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
})), _class2)) || _class) || _class;

var _default = DocumentTableBody;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(CheckboxTable, 'CheckboxTable', '/app/src/components/common/DocumentTableBody.js');
  reactHotLoader.register(DocumentTableBody, 'DocumentTableBody', '/app/src/components/common/DocumentTableBody.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/common/DocumentTableBody.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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